import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-activities-lite',
    templateUrl: './activities-lite.component.html',
    styleUrls: ['./activities-lite.component.scss'],
    standalone: false
})
export class ActivitiesLiteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    return;
  }

}

